class SubscriptionModal extends HTMLElement {
  constructor() {
    super();

    // Get the settings
    this.formId = this.dataset.formId;
    this.closeDelayDays = this.dataset.closeDelay;
    this.showTimerDelay = this.dataset.timerDelay;

    // Get the elements
    this.overlay = document.querySelector('site-overlay');
    this.closeButton = this.querySelector('[data-subscription-modal-close]');
    this.introEl = this.querySelector('[data-subscription-modal-intro]');

    // Bind the event listeners
    window.addEventListener('klaviyoForms', this.handleFormSubmit.bind(this));
    this.overlay.addEventListener('overlayClicked', this.close.bind(this));
    this.closeButton.addEventListener('click', () => {
      this.close(true)
    });

    this.checkStatusAndOpen();
  }

  checkStatusAndOpen() {
    const lastCloseDate = localStorage.getItem('lastPopupCloseDate');
    const isSubmitted = localStorage.getItem('popupSubmitted');
    const currentDate = new Date();
    const closeDelay = this.closeDelayDays * 24 * 60 * 60 * 1000; // in milliseconds
    const showTimerDelay = this.showTimerDelay * 1000; // in milliseconds

    if (!isSubmitted) {
      if (lastCloseDate) {
        const lastCloseDateTime = new Date(lastCloseDate).getTime();
        if (currentDate.getTime() - lastCloseDateTime > closeDelay) {
          setTimeout(this.open.bind(this), showTimerDelay);
        }
      } else {
        setTimeout(this.open.bind(this), showTimerDelay);
      }
    }
  }

  handleFormSubmit(e) {
    if (e.detail.formId == this.formId && e.detail.type == 'submit') {
      this.introEl.classList.add('d-none');
      localStorage.setItem('popupSubmitted', 'true');
    }
  }

  open() {
    this.classList.add('open');

    if (this.overlay) {
      this.overlay.showOverlay();
    }
  }

  close(hideOverlay = false) {
    if (!this.classList.contains('open')) {
      return;
    }

    this.classList.remove('open');

    if (hideOverlay && this.overlay) {
      this.overlay.hideOverlay();
    }
    
    const currentDate = new Date();
    localStorage.setItem('lastPopupCloseDate', currentDate.toISOString());
  }
}

customElements.define('subscription-modal', SubscriptionModal);